import React from 'react';
import {View} from 'react-native';

import Checkbox from '/component/base/Checkbox';
import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';

import ListItem from '../ListItem';

import {styles} from './ListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={1}>Prefix, Label and Suffix</Heading>
      <Spacer size={16} />
      <Text>
        This is a <Code>{'ListItem'}</Code> with all three props. This also
        demonstrates the layout when the <Code>{'label'}</Code> has multiple
        levels of text.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter style={styles.gutter}>
        <ListItem
          prefix={<Checkbox checked />}
          label={<Text>Frontline Qualifying Volume</Text>}
          suffix={<Text emphasis="low">600 / 600</Text>}
        />
      </Gutter>
      <Gutter style={styles.gutter}>
        <ListItem
          prefix={<Checkbox />}
          label={<Text>Group Qualifying Volume for Senior for Coach Rank</Text>}
          suffix={<Text emphasis="low">571 / 700</Text>}
        />
      </Gutter>
    </View>
  </>
);
